import "./App.css";
import Navbar from "./components/UI/navbar";
import Mainview from "./components/mainview";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Mainview />
      </div>
    </Router>
  );
}

export default App;
